export default __webpack_public_path__ + "static/media/zertiassist_iconos_categories_24px.2d65a1e8.svg";